export var STYLE_TAG_ID="dsTextTrackDisplayStyle";